import { useDappState } from '@src/hooks/useDappState';
import { HStack, Text } from 'ui_2';
import parcIcon from '@assets/parc.png';
import partIcon from '@assets/part.png';

export const ParcBalance = () => {
  const { parcBalance, isPro } = useDappState();

  if (parcBalance !== undefined) {
    return (
      <div className='relative'>
        {isPro && (
          <div className='absolute -left-[36px] -top-2 z-10 rounded-full bg-secondary-yellow px-2 py-1'>
            <Text font={'xs'} className='items-center'>
              +1 <span className='text-[8px] text-gray-600'>/day</span>
            </Text>
          </div>
        )}
        <HStack className='items-center gap-2 rounded-[10px] border border-gray-100 px-3 py-2'>
          <img src={parcIcon} className='h-[18px] w-[18px]' />
          <Text>{parcBalance}</Text>
        </HStack>
      </div>
    );
  }
};

export const PartBalance = () => {
  const { partBalance } = useDappState();

  if (partBalance !== undefined) {
    return (
      <HStack className='items-center gap-2 rounded-[10px] border border-gray-100 px-3 py-2'>
        <img src={partIcon} className='h-[18px] w-[18px]' />
        <Text>{partBalance}</Text>
      </HStack>
    );
  }
};

export const Balances = () => {
  return (
    <HStack className='items-center gap-4'>
      <ParcBalance />
      <PartBalance />
    </HStack>
  );
};
